import React from 'react';
const Sales = () => <div className="p-8"><h1 className="text-2xl font-bold">Sales Page</h1></div>;
export default Sales; 